<template>
  <v-container fluid>
    <v-layout xs12 align-start row wrap>
      <v-flex xs12 sm12 md12 justify-center>
        <h2 class="ml-2 mb-2">{{ titulo }}</h2>
        <v-data-table
          :headers="headers"
          :items="$apollo.data.banners"
          :loading="$apollo.loading"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat height="100">
              <div class="md8 mr-11 ml-2 row sm10 xs10">
                <v-flex xs12 sm12 md3 py-2>
                  <v-text-field
                    v-model="filters.title"
                    flat
                    hide-details
                    label="Titulo"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3 py-2>
                  <v-select
                    v-model="filters.enabled"
                    :items="[
                      { text: 'Sim', value: true },
                      { text: 'Não', value: false }
                    ]"
                    item-text="text"
                    item-value="value"
                    id="enabled"
                    label="Ativo"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md3 py-2>
                  <ApolloQuery
                    :query="
                      gql => gql`
                        query ListDrugstores {
                          drugstores(where: { enabled: { _eq: true } }) {
                            id
                            name
                          }
                        }
                      `
                    "
                  >
                    <template v-slot="{ result: { data } }">
                      <v-autocomplete
                        v-if="data"
                        v-model="filters.id_drugstore"
                        v-bind:items="toArray(data.drugstores)"
                        id="id_drugstore"
                        label="Farmácia"
                        item-text="name"
                        item-value="id"
                        @keyup.delete="filters.id_drugstore = null"
                      >
                      </v-autocomplete>
                    </template>
                  </ApolloQuery>
                </v-flex>
              </div>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on"
                    >Adicionar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="form"
                        v-model="valid"
                        :lazy-validation="lazy"
                      >
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model.lazy="editedItem.title"
                              id="title"
                              label="Titulo"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-select
                              v-model="editedItem.paid"
                              :items="[
                                { text: 'Sim', value: true },
                                { text: 'Não', value: false }
                              ]"
                              item-text="text"
                              item-value="value"
                              id="paid"
                              label="Pago"
                            ></v-select>

                            <ApolloQuery
                              :query="
                                gql => gql`
                                  query ListDrugstores {
                                    drugstores(
                                      where: { enabled: { _eq: true } }
                                    ) {
                                      id
                                      name
                                    }
                                  }
                                `
                              "
                            >
                              <template v-slot="{ result: { data } }">
                                <v-autocomplete
                                  v-if="data"
                                  v-model="editedItem.id_drugstore"
                                  v-bind:items="toArray(data.drugstores)"
                                  id="id_drugstore"
                                  label="Farmácia*"
                                  item-text="name"
                                  item-value="id"
                                  :rules="rules"
                                  required
                                >
                                </v-autocomplete>
                              </template>
                            </ApolloQuery>

                            <ApolloQuery
                              :query="
                                gql => gql`
                                  query ListProducts {
                                    prices(
                                      where: { enabled: { _eq: true } }
                                      order_by: { product: { name: asc } }
                                    ) {
                                      id
                                      product {
                                        id
                                        name
                                        information
                                      }
                                    }
                                  }
                                `
                              "
                            >
                              <template v-slot="{ result: { data } }">
                                <v-autocomplete
                                  v-if="data"
                                  v-model="editedItem.id"
                                  v-bind:items="toArray(data.prices)"
                                  id="id"
                                  label="Produto*"
                                  item-text="product.name"
                                  item-value="id"
                                  :rules="rules"
                                  required
                                >
                                </v-autocomplete>
                              </template>
                            </ApolloQuery>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.paid`]="{ item }">
            {{ item.paid ? "Sim" : "Não" }}
          </template>
          <template v-slot:[`item.enabled`]="{ item }">
            {{ item.enabled ? "Sim" : "Não" }}
          </template>
          <template v-slot:[`item.action`]="{ item }" style="width: 75px;">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  GetBanners,
  DeleteBanners,
  InsertBanners,
  UpdateBanners
} from "../../graphql/banners.gql";

export default {
  name: "banners-list",
  data: () => ({
    dialog: false,
    valid: true,
    lazy: false,
    menu: false,
    titulo: "Banners",
    filters: {
      title: null,
      paid: false,
      enabled: null,
      id_drugstore: null
    },
    headers: [
      { text: "Titulo", value: "title" },
      { text: "Farmácia", value: "drugsto.name" },
      { text: "Pago", value: "paid" },
      { text: "Ativo", value: "enabled" },
      { text: "Ações", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      title: null,
      order: 0,
      enabled: true,
      paid: false,
      id_drugstore: null
    },
    defaultItem: {
      id: null,
      title: null,
      order: 0,
      enabled: true,
      paid: null,
      id_drugstore: null
    },
    rules: [v => !!v || "Campo obrigatório!"]
  }),

  apollo: {
    banners: {
      query: GetBanners,
      variables() {
        return {
          title: this.filters.title
            ? "%" + this.filters.title + "%"
            : this.filters.title,
          enabled: this.filters.enabled,
          id_drugstore: this.filters.id_drugstore
        };
      }
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Banner" : "Editar Banner";
    }
  },

  mounted: function() {},

  watch: {
    dialog(val) {
      val || this.close();
    },

    "filters.title": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.title = null;
          }
        }
      }
    }
  },

  methods: {
    clear(value) {
      if (!value) {
        return null;
      }
    },

    editItem(item) {
      this.editedIndex = this.$apollo.data.banners.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.$apollo.data.banners.indexOf(item);
      confirm("Desativar Banner?") &&
        this.$apollo.data.banners.splice(index, 1) &&
        this.$apollo
          .mutate({
            mutation: DeleteBanners,
            variables: {
              id: item.id
            }
          })
          .then(() => {
            this.$swal("Banner desativado com sucesso!", "", "success");
          })
          .catch(() => {
            this.$swal("Erro ao desativado o banner!", "", "error");
          });
    },

    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },

    save() {
      this.$apollo
        .mutate({
          // Query
          mutation: this.editedItem.id !== null ? UpdateBanners : InsertBanners,
          // Parameters
          variables: {
            id: this.editedItem.id,
            title: this.editedItem.title,
            order: this.editedItem.order,
            enabled: this.editedItem.enabled,
            paid: this.editedItem.paid,
            id_drugstore: this.editedItem.id_drugstore
          }
        })
        .then(data => {
          if (this.editedItem.id !== null) {
            Object.assign(
              this.$apollo.data.banners[this.editedIndex],
              data.data.update_banners.returning[0]
            );
          } else {
            this.$apollo.data.banners.push(
              data.data.insert_banners.returning[0]
            );
          }
          this.close();
          this.$swal("Banner salvo com sucesso!", "", "success");
        })
        .catch(() => {
          //console.log(error);
          this.close();
          this.$swal("Erro ao salvar o banner!", "", "error");
        });
    },

    toArray(array) {
      let items = [];
      array.forEach(v => items.push(v));
      return items;
    }
  }
};
</script>

<style lang="stylus"></style>
